import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, FormGroup, Input, Button, UncontrolledAlert } from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
import { AccountActions } from '../../../actions';
import LoadingOverlay from '../../../components/LoadingOverlay';

class Reset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      message: '',
      loading: false,
      success: false
    };
  }

  handleChange = e => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  handleSubmit = e => {
    e.preventDefault();
    const { password, confirmPassword } = this.state;
    if (password != confirmPassword) {
      this.setState({
        message: "S'il vous plaît confirmer le mot de passe"
      });
      return;
    }

    this.setState(
      {
        loading: true,
        message: ''
      },
      () => {
        let tmp = window.location.hash.split('?token=');
        let token = tmp[1];
        this.props.resetEmail({
          token: token,
          password: password,
          cb: res => {
            this.setState({
              message: res.error ? 'Une erreur est survenue' : '',
              loading: false,
              success: res.error ? false : true
            });
          }
        });
      }
    );
  };

  render() {
    const { intl } = this.props;
    const { password, confirmPassword, message, loading, success } = this.state;
    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        {success ? (
          <UncontrolledAlert className="bg-success text-white shadow-lg">
            Votre mot de passe a été réinitialisé
          </UncontrolledAlert>
        ) : (
          <div className="login-content">
            <div className="login-header mb-4 text-center">
              <Link className="app-logo" to="/" title="BeDaddy">
                <img src="images/logo.png" alt="BeDaddy" title="BeDaddy" />
              </Link>
            </div>

            <div className="login-form">
              <Form onSubmit={this.handleSubmit}>
                <FormGroup className="mb-4">
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    value={password}
                    onChange={this.handleChange}
                    required
                    placeholder={intl.formatMessage({ id: 'pages.account.password' })}
                  />
                </FormGroup>
                <FormGroup className="mb-4">
                  <Input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleChange}
                    required
                    placeholder={'Confirmez le mot de passe'}
                  />
                </FormGroup>

                <div className="loginbtn-wrapper">
                  {loading && (
                    <div className="loading">
                      <svg className="circular" viewBox="25 25 50 50">
                        <circle
                          className="path"
                          cx="50"
                          cy="50"
                          r="15"
                          fill="none"
                          strokeWidth="2"
                          strokeMiterlimit="10"
                        ></circle>
                      </svg>
                    </div>
                  )}
                  <Button className="jr-btn btn-primary btn btn-default" disabled={loading}>
                    <IntlMessages id="appModule.signIn" />
                  </Button>
                </div>
                {message && <UncontrolledAlert className="bg-danger text-white shadow-lg">{message}</UncontrolledAlert>}
              </Form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Reset.propTypes = {
  intl: intlShape.isRequired
};

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    resetEmail: req => dispatch(AccountActions.resetEmail(req.token, req.password, req.cb))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Reset));



// WEBPACK FOOTER //
// ./app/routes/Reset/index.js